import React from 'react';
import * as Yup from 'yup';
import { BiImage } from 'react-icons/bi';

import Input from '../../../../../../newComponents/UnformInput';
import FileInput from '../../../../../../newComponents/FileInput';

import { usePizzaGroup } from '../../../../../../hooks/pizzaGroup';

import { Container } from './styles';

export const DetailsFormSchema = Yup.object().shape({
  name: Yup.string()
    .max(40, 'No máximo 40 caracteres')
    .required('O nome é obrigatório'),
});

const Details: React.FC = () => {
  const { image, handleChangeGroup } = usePizzaGroup();

  return (
    <Container>
      <FileInput
        id="pizzaGroupImage"
        icon={BiImage}
        title="Escolha uma imagem"
        selectedImage={image}
        acceptableTypes=".jpeg,.jpg,.png"
        subtitle="Formatos: .jpeg, .jpg, .png"
        onRemove={() => handleChangeGroup({ image: undefined })}
        onSelectFile={(selectedFile) => {
          handleChangeGroup({ image: selectedFile });
        }}
      />
      <Input id="name" name="name" label="Nome" placeholder="Ex.: Promoções" />
    </Container>
  );
};

export default Details;
